var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { Typography, Card, StackWrap } from '@telus-uds/components-web';
import _isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import RichText from '../RichText/RichText';
export var BottomTabFilterContent = function (_a) {
    var bottomTabFilter = _a.bottomTabFilter, globalCopy = _a.globalCopy, offerId = _a.offerId, setOfferId = _a.setOfferId, setTabSwitch = _a.setTabSwitch, lang = _a.lang, length = _a.length, hasPlans = _a.hasPlans;
    var content = bottomTabFilter.content;
    var title = content.title, description = content.tabBottomDescription, amount = content.lowestPricePlan.amount;
    var _b = globalCopy || {}, labelPerMonth = _b.labelPerMonth, plansMinPrice = _b.plansMinPrice;
    var currencyEN = lang === 'en' ? '$' : '';
    var currencyFR = lang === 'fr' ? '$' : '';
    var renderPlansMinPrice = useMemo(function () {
        var minPrice = hasPlans ? "".concat(amount, ".00") : '-';
        return (_jsxs(StackWrap, { direction: "row", children: [_jsxs(Typography, { children: [plansMinPrice, " "] }), _jsx(Typography, { variant: { bold: true }, children: " ".concat(currencyEN).concat(minPrice).concat(currencyFR).concat(labelPerMonth) })] }));
    }, [amount, plansMinPrice, labelPerMonth, lang, hasPlans]);
    var handleOnClick = function () {
        setOfferId(offerId);
        setTabSwitch(true);
    };
    useEffect(function () {
        // adding timeout, so that scroll can be done after component is re-rendered.
        var timeout = setTimeout(function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 50);
        return function () { return clearTimeout(timeout); };
    }, [offerId]);
    return (_jsx(StyleContainer, { length: length, children: _jsx(Card, { variant: { background: 'grid' }, tokens: {
                minWidth: '240px'
            }, onPress: handleOnClick, "data-testid": "bottomTabFilter".concat(offerId), interactiveCard: {
                tokens: { paddingTop: 12, paddingBottom: 12, paddingLeft: 12, paddingRight: 12 },
                body: (_jsxs(_Fragment, { children: [_jsx(Typography, { heading: "h4", variant: { size: 'h4' }, children: title }), !_isEmpty(description) && _jsx(RichText, { content: description }), renderPlansMinPrice] }))
            } }) }));
};
// --------------------------- STYLES --------------------------- //
var StyleContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: 100%;\n\n  > div {\n    height: inherit;\n  }\n"], ["\n  width: ", ";\n  height: 100%;\n\n  > div {\n    height: inherit;\n  }\n"])), function (props) { return (props.length === 1 ? '50%' : '100%'); });
var templateObject_1;
